(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
  const timelines = new Set();
  let timelineFrame = 0;
  const updateTimelines = () => {
    timelineFrame = 0;
    timelines.forEach(timeline => {
      if (!timeline.container.isConnected) { timelines.delete(timeline); return; }
      const {wrapper, line, progress, rows} = timeline;
      const top = wrapper.getBoundingClientRect().top;
      const centers = rows.map(row => {
        const node = row.querySelector('.tle-center-node');
        return node.getBoundingClientRect().top + node.offsetHeight / 2;
      });
      const height = centers[centers.length - 1] - top;
      line.style.height = `${height}px`;
      let activeCenter = top;
      rows.forEach((row, index) => {
        const active = reducedMotion.matches || centers[index] <= innerHeight * .75;
        row.classList.toggle('tl-active', active);
        if (active) activeCenter = centers[index];
      });
      progress.style.height = `${height > 0 ? Math.max(0, Math.min(100, (activeCenter - top) / height * 100)) : 0}%`;
    });
  };
  const scheduleTimelines = () => { if (!timelineFrame) timelineFrame = requestAnimationFrame(updateTimelines); };
  addEventListener('scroll', scheduleTimelines, {passive:true});
  addEventListener('resize', scheduleTimelines, {passive:true});
  reducedMotion.addEventListener('change', scheduleTimelines);
  const timelineResize = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleTimelines) : null;
  const init = (root = document) => {
    root.querySelectorAll('[data-dominion-timeline]').forEach(container => {
      if (container.dataset.oaReady) return;
      const wrapper = container.querySelector('.timeline-wrapper');
      const line = container.querySelector('.timeline-line');
      const progress = container.querySelector('.timeline-line-progress');
      const rows = [...container.querySelectorAll('.timeline-event-row')];
      if (!wrapper || !line || !progress || !rows.length) return;
      container.dataset.oaReady = 'true';
      timelines.add({container, wrapper, line, progress, rows});
      timelineResize?.observe(wrapper);
    });
    scheduleTimelines();
    root.querySelectorAll('.statistics-column__item').forEach(item => {
      if (item.dataset.oaReady) return;
      const number = item.querySelector('[data-count-to]');
      if (!number) return;
      const target = Number.parseFloat(number.dataset.countTo);
      if (!Number.isFinite(target)) return;
      item.dataset.oaReady = 'true';
      const finalText = number.textContent;
      const suffix = number.dataset.suffix || '';
      const fill = item.querySelector('.statistics-column__progress-fill');
      const animate = () => {
        if (reducedMotion.matches) return;
        const started = performance.now();
        number.setAttribute('aria-label', finalText);
        const tick = now => {
          const progress = Math.min((now - started) / 2000, 1);
          const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
          const value = eased * target;
          number.textContent = progress === 1 ? finalText : (Number.isInteger(target) ? Math.floor(value).toLocaleString() : value.toFixed(1)) + suffix;
          if (fill) fill.style.setProperty('--progress-value', `${value}%`);
          if (progress < 1 && number.isConnected && !reducedMotion.matches) requestAnimationFrame(tick);
          else { number.textContent = finalText; if (fill) fill.style.setProperty('--progress-value', `${target}%`); }
        };
        requestAnimationFrame(tick);
      };
      if ('IntersectionObserver' in window && !reducedMotion.matches) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); animate(); }
        }, {threshold:.15, rootMargin:'0px 0px -40px 0px'});
        observer.observe(item);
      }
    });
    root.querySelectorAll('[data-oa-section="main_product"]').forEach(section => {
      if (section.dataset.oaReady) return;
      section.dataset.oaReady = 'true';
      const form = section.querySelector('.oa-product-form');
      if (!form) return;
      const button = form.querySelector('[data-oa-add]');
      const total = button.querySelector('[data-oa-total]');
      const notice = form.querySelector('[data-oa-offer-message]');
      const subscription = section.querySelector('[data-oa-subscription]');
      const plan = section.querySelector('[data-oa-plan]');
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
      const update = () => {
        const selected = section.querySelector('[name="oa-offer"]:checked');
        if (!selected) return;
        const quantity = Number(selected.value);
        const paid = Number(selected.dataset.paid);
        let unit = Number(section.dataset.unitPrice);
        const sellingPlan = form.querySelector('[name="selling_plan"]');
        const subscribes = subscription?.checked && !!plan?.value;
        sellingPlan.disabled = !subscribes;
        sellingPlan.value = subscribes ? plan.value : '';
        if (subscribes) unit = Number(plan.selectedOptions[0].dataset.price);
        form.querySelector('[name="quantity"]').value = quantity;
        section.querySelectorAll('.quantity-break-option').forEach(label => label.classList.toggle('selected', label.contains(selected)));
        total.textContent = `• ${money(unit * paid)}`;
        const unavailable = section.dataset.available !== 'true' || (quantity > 1 && section.dataset.bundlesReady !== 'true');
        button.disabled = unavailable;
        notice.hidden = !unavailable;
      };
      section.addEventListener('change', update);
      form.addEventListener('submit', event => { update(); if (button.disabled) event.preventDefault(); });
      update();
      const slides = [...section.querySelectorAll('.oa-gallery-slide')];
      const thumbs = [...section.querySelectorAll('[data-gallery-index]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide,i) => slide.hidden = i !== current);
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed', String(i === current)));
      };
      thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => show(i)));
      section.querySelector('.oa-gallery-main')?.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      let touchStart;
      section.querySelector('.oa-gallery-main')?.addEventListener('touchstart', event => touchStart = event.changedTouches[0].clientX, {passive:true});
      section.querySelector('.oa-gallery-main')?.addEventListener('touchend', event => {
        const change = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(change) > 45) show(current + (change < 0 ? 1 : -1));
      }, {passive:true});
    });
    root.querySelectorAll('.faq-question,.store-faq-question').forEach(button => {
      if (button.dataset.oaReady) return;
      button.dataset.oaReady = 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = button.getAttribute('aria-expanded') !== 'true';
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        button.closest('.faq-item,.store-faq-item')?.classList.toggle('active', open);
        panel.style.height = open ? 'auto' : '';
        panel.style.maxHeight = open ? 'none' : '';
      });
    });
    root.querySelectorAll('[data-oa-scroll]').forEach(track => {
      const section = track.closest('.oa-section');
      if (track.dataset.oaReady) return;
      track.dataset.oaReady = 'true';
      section.querySelectorAll('button').forEach(button => {
        const label = button.getAttribute('aria-label') || '';
        if (!/previous|next/i.test(label)) return;
        button.disabled = false;
        button.addEventListener('click', () => {
          const card = track.firstElementChild;
          const direction = /previous/i.test(label) ? -1 : 1;
          track.scrollBy({left:direction * ((card?.getBoundingClientRect().width || 300) + 20),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
